var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width })},[_c('a-select',{staticClass:"ts-w-full",attrs:{"showSearch":"","mode":"multiple","placeholder":_vm.placeholder,"optionFilterProp":"children","loading":_vm.loading,"maxTagTextLength":17,"maxTagCount":1,"options":_vm.options.map(el => ({
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en + ' | ' + el.company.company_name_en
        })),"filterOption":(input, option) =>
    option.componentOptions.children[0].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }